import React from 'react';

type Props = {
  width?: number;
  height?: number;
  fill?: string;
};

// Rounded outline "alert triangle" — used for the broken custom-filter-variable badge.
// `fill` drives the stroke colour so it matches the icon API used elsewhere.
const AlertTriangleIcon = ({ width, height, fill }: Props) => (
  <svg
    style={{ width, height }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 9v4" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 17h.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

AlertTriangleIcon.defaultProps = {
  fill: 'var(--dangerColor)',
  width: 16,
  height: 16,
};

export default AlertTriangleIcon;
